export const priceNameMap: Record<string, string> = {
  DriveKr: "Basic",
  DriveEn: "Basic",
  BasicKr: "Standard",
  BasicEn: "Standard",
  BasicPlusKr: "Standard Plus",
  BasicPlusEn: "Standard Plus",
  PlusKr: "Enterprise",
  PlusEn: "Enterprise",
  PlusPlusKr: "Enterprise Plus",
  PlusPlusEn: "Enterprise Plus",
};
